import React from "react";
import GrindPodTin from "assets/img/grindPodTin.png";
import GiftSubscription from "assets/img/giftSubscription.gif";
import Card from "shared/Card";

const Layout = ({ children, gift }) => {
  return (
    <Card className="pb-0 mt-md-5">
      <div className="row">
        <div className="col-12 col-md-6 mb-4">{children}</div>
        <div className="d-none d-md-block col-6 position-relative overflow-hidden">
          <img
            className={`${!gift ? "w-100" : "h-100"} position-absolute`}
            src={gift ? GiftSubscription : GrindPodTin}
            alt="Grind pod tin"
          />
        </div>
      </div>
    </Card>
  );
};

export default Layout;
